import type IAuthTokenProvider from "@/domain/ports/IAuthTokenProvider";

export default class AuthTokenProvider implements IAuthTokenProvider {
  retrieveAuthToken() {
    return localStorage.getItem(process.env.VUE_APP_API_TOKEN_KEY || "")
  }
  saveAuthToken(token: string) {
    return localStorage.setItem(process.env.VUE_APP_API_TOKEN_KEY, token)
  }
}
